<div class="pt-5">

  <!-- MAIN COLUMN -->
  <div class="px-3 2xl:px-6">

    <article class="w-full bg-white">

      <!-- TABLE ACTIONS + TOP PAGINATION -->
      <div class="px-4 pt-4 sm:px-6 2xl:px-8">
        <div class="grid grid-cols-12 items-center gap-4 rounded-2xl bg-white/95 p-4 backdrop-blur">

          <!-- ADD BUTTON -->
          <div class="col-span-12 md:col-span-3 lg:col-span-3">
            <button
              class="primary-btn h-[50px] w-full rounded-xl px-5 text-sm font-semibold transition sm:w-auto"
              (click)="addNewRssFeed()">
              Add Category
            </button>
          </div>

          <!-- TOP PAGINATION -->
          <div class="col-span-12 md:col-span-9 lg:col-span-9">
            <div class="flex items-center justify-end">
              <div class="w-fit overflow-hidden rounded-xl bg-white">
                <mat-paginator
                  [length]="rssFeedsDataSource.data.length"
                  [pageSize]="12"
                  showFirstLastButtons>
                </mat-paginator>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- TABLE SECTION -->
      <div class="px-4 py-4 sm:px-6 2xl:px-8 2xl:py-6">
        <div class="overflow-hidden rounded-2xl bg-white">
          <div class="w-full overflow-x-auto">

            <mat-table
              [dataSource]="rssFeedsDataSource"
              matSort
              class="table-alternate !inline-table !w-full min-w-[1000px]">

              <!-- ID -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="id">
                  ID
                </th>

                <td
                  mat-cell
                  *matCellDef="let feed"
                  class="cursor-pointer"
                  (click)="onFeedSelected(feed)">
                  <span class="font-medium text-gray-700">
                    {{ feed.id }}
                  </span>
                </td>
              </ng-container>

              <!-- Site -->
              <ng-container matColumnDef="site">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="site">
                  Social Page/Site
                </th>

                <td
                  mat-cell
                  *matCellDef="let feed"
                  class="cursor-pointer max-w-[240px]"
                  (click)="onFeedSelected(feed)">
                  <span class="block truncate text-gray-700">
                    {{ feed.Domain || feed.site_name || '-' }}
                  </span>
                </td>
              </ng-container>

              <!-- Name -->
              <ng-container matColumnDef="feed">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="feed">
                  Name
                </th>

                <td
                  mat-cell
                  *matCellDef="let feed"
                  class="cursor-pointer"
                  (click)="onFeedSelected(feed)">
                  <span class="block max-w-xs truncate font-medium text-gray-800">
                    {{ feed.feed }}
                  </span>
                </td>
              </ng-container>

              <!-- URL -->
              <ng-container matColumnDef="url">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="url">
                  URL
                </th>

                <td
                  mat-cell
                  *matCellDef="let feed"
                  class="cursor-pointer max-w-[320px]"
                  (click)="onFeedSelected(feed)">
                  <a
                    [href]="feed.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="block truncate text-blue-600 transition-colors duration-200 hover:text-blue-800 hover:underline"
                    [title]="feed.url"
                    (click)="$event.stopPropagation()">
                    {{ feed.url }}
                  </a>
                </td>
              </ng-container>

              <!-- Status -->
              <ng-container matColumnDef="isApproved">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="isApproved">
                  Status Approval
                </th>

                <td mat-cell *matCellDef="let feed">
                  <span class="inline-flex max-w-xs items-center rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs font-semibold text-gray-700">
                    {{ feed.isApproved }}
                  </span>
                </td>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                  Action
                </th>

                <td mat-cell *matCellDef="let feed">
                  <div class="flex flex-row items-center gap-2">

                    <button
                      mat-icon-button
                      class="!bg-slate-500 !text-white"
                      matTooltip="Edit"
                      (click)="editRssFeed(feed); $event.stopPropagation()">
                      <mat-icon>edit</mat-icon>
                    </button>

                    <button
                      mat-icon-button
                      class="!bg-blue-500 !text-white"
                      matTooltip="View Slots"
                      (click)="viewSlotsForFeed(feed); $event.stopPropagation()">
                      <mat-icon>schedule</mat-icon>
                    </button>

                  </div>
                </td>
              </ng-container>

              <!-- Header and Row Definitions -->
              <tr mat-header-row *matHeaderRowDef="rssDisplayedColumns"></tr>

              <tr
                mat-row
                *matRowDef="let row; columns: rssDisplayedColumns"
                class="cursor-pointer transition-colors duration-150 hover:bg-gray-50"
                [class.bg-blue-100]="row === selectedRssFeed"
                (click)="onFeedSelected(row)">
              </tr>

            </mat-table>

          </div>
        </div>
      </div>

      <!-- BOTTOM PAGINATION -->
      <div class="px-4 pb-4 sm:px-6 2xl:px-8">
        <div class="flex items-center justify-end rounded-2xl bg-white/95 p-4 backdrop-blur">
          <div class="w-fit overflow-hidden rounded-xl bg-white">
            <mat-paginator
              [length]="rssFeedsDataSource.data.length"
              [pageSize]="12"
              showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>
      </div>

    </article>

    <!-- DIALOG TEMPLATES -->
    <ng-template #rssFeedFormTmpl>
      <app-rss-feeds-form
        [formData]="rssFeed"
        [companyID]="+companyID!"
        (onSubmitClbk)="onSubmitClbk($event)">
      </app-rss-feeds-form>
    </ng-template>

    <ng-template #weeklySlotFormTmpl>
      <app-social-ai-scheduler-form
        [formData]="weeklySlot"
        (onSubmitClbk)="onSubmitClbk($event)">
      </app-social-ai-scheduler-form>
    </ng-template>

    <!-- SLOTS DIALOG TEMPLATE -->
    <ng-template #viewSlotsTmpl>
      <div class="max-w-full p-4">
        
        <!-- Conditional buttons: Auto Create Slots or Clear All Slots -->
        <div class="flex justify-center mb-4">
          <ng-container *ngIf="!hasSlots(); else clearSlotsButton">
            <button mat-stroked-button (click)="autoCreateSlots()" 
                    class="!h-8 !rounded-full !border-blue-300 !px-4 !text-xs !font-medium text-blue-600">
              <span class="mdc-button__label">Auto Create Slots</span>
            </button>
          </ng-container>
          
          <ng-template #clearSlotsButton>
            <button mat-stroked-button (click)="clearAllSlotsForSelectedFeed()" 
                    class="!h-8 !rounded-full !border-rose-300 !px-4 !text-xs !font-medium text-rose-600">
              <span class="mdc-button__label">Clear All Slots</span>
            </button>
          </ng-template>
        </div>

        <div *ngIf="selectedRssFeed && allSocialMediaSlotsForDisplay.size > 0; else noSlots">

          <div
            *ngFor="let platformEntry of allSocialMediaSlotsForDisplay | keyvalue"
            class="mb-4 rounded-2xl border border-gray-200 bg-white p-5 shadow-sm last:mb-0">

            <!-- PLATFORM SLOT HEADER -->
            <div class="mb-5 grid grid-cols-12 items-center gap-4">

              <div class="col-span-12 sm:col-span-8">
                <p class="mb-0.5 text-base font-semibold text-gray-900">
                  {{ platformEntry.key }}
                </p>

                <p class="text-xs text-gray-400">
                  Weekly auto-scheduling times
                </p>
              </div>

              <div class="col-span-12 flex justify-start sm:col-span-4 sm:justify-end">
                <ng-container *ngIf="isPlatformRegistered(platformEntry.key); else notRegistered">
                  <button
                    mat-stroked-button
                    class="!h-8 !rounded-full !border-gray-300 !px-4 !text-xs !font-medium text-blue-600"
                    (click)="addNewWeeklySlot(selectedRssFeed!.id, selectedRssFeed!.feed, platformEntry.key)">
                    + Insert slots
                  </button>
                </ng-container>

                <ng-template #notRegistered>
                  <span class="rounded-full bg-red-50 px-3 py-1 text-[11px] font-medium text-red-600">
                    No platform for this site
                  </span>
                </ng-template>
              </div>

            </div>

            <!-- PLATFORM SLOT DAYS -->
            <div *ngFor="let entry of platformEntry.value" class="mb-3 last:mb-0">
              <div class="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-7">

                <div
                  *ngFor="let i of [0,1,2,3,4,5,6]"
                  class="rounded-xl border border-gray-100 bg-gray-50 p-2">

                  <p class="mb-2 text-center text-[10px] font-semibold uppercase tracking-wider text-gray-400">
                    {{ weekdaysOrdered[i].slice(0,3) }}
                  </p>

                  <ng-container *ngIf="(entry.slotsByDay[i] || []).length > 0; else emptyDay">
                    <div>

                      <div
                        *ngFor="let slot of entry.slotsByDay[i]; let timeIndex = index"
                        class="relative"
                        [class.mb-1.5]="timeIndex < (entry.slotsByDay[i] || []).length - 1">

                        <input
                          type="text"
                          [value]="slot.time | slice:0:5"
                          (blur)="onTimeChange($event, entry, i, timeIndex, slot.weekly_slot_id)"
                          (keydown.enter)="onTimeChange($event, entry, i, timeIndex, slot.weekly_slot_id)"
                          class="w-full rounded-lg border border-gray-200 bg-white py-1.5 pl-2 pr-7 text-center text-xs font-medium text-gray-800 outline-none transition-colors duration-200 focus:border-blue-400"
                          placeholder="HH:MM"
                          maxlength="5" />

                        <button
                          type="button"
                          class="absolute right-1.5 top-1/2 -translate-y-1/2 text-xs leading-none text-gray-300 transition-colors duration-200 hover:text-red-400"
                          (click)="deleteSlot(slot.weekly_slot_id)">
                          ✕
                        </button>

                      </div>

                    </div>
                  </ng-container>

                  <ng-template #emptyDay>
                    <div class="flex min-h-[40px] items-center justify-center rounded-lg border border-dashed border-gray-200">
                      <span class="text-[10px] text-gray-300">
                        No times
                      </span>
                    </div>
                  </ng-template>

                </div>

              </div>
            </div>

          </div>

        </div>

        <ng-template #noSlots>
          <div class="flex min-h-[200px] flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-6 text-center">
            <p class="mb-1 text-sm font-semibold text-gray-600">
              No slots defined for this feed
            </p>

            <p class="max-w-sm text-xs leading-5 text-gray-400">
              Add weekly auto-scheduling times for at least one platform to start scheduling posts automatically.
            </p>
          </div>
        </ng-template>

      </div>
    </ng-template>

  </div>

</div>